import { clsx } from 'clsx'
import { Button } from 'component/Button'
import { Space } from 'component/Space'
import { Vertical } from 'component/Vertical'
import { try_on } from 'feature/widget/TryOnStore'
import { ym } from 'feature/yama'
import { useBodyScrollLock } from 'hook/useBodyScrollLock'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { ItemsPane } from 'page/catalog/ItemPreviewBasic/ItemsPane'
import { MainCard } from 'page/catalog/ItemPreviewBasic/MainCard'
import { demo } from 'page/catalog/store/CatalogStore'
import { itemPreview } from 'page/catalog/store/ItemPreviewStore'
import { opt } from 'store/opt'
import css from './ItemPreviewBasic.module.scss'

export const ItemPreviewBasic = observer(() => {
  const { item, combo } = itemPreview.it
  const mix = demo.it.canMix(item)

  useBodyScrollLock(true)

  const onTry = useLatestCallback(() => {
    const item_id = item.item_id
    const combo_item_id = combo?.item_id

    ym('click_try_on', { from: 'basic_preview', item_id })
    void try_on.open(item_id, combo_item_id)
    itemPreview.close()
  })

  const onClose = useLatestCallback(() => {
    itemPreview.close()
  })

  const button = <Space pad={32} margin={opt.sochi ? [80, null, null, null] : undefined}>
    <Button className={css.try} large primary action={onTry}>
      {!mix ? i18n('demo.TryOn') : combo ? i18n('TryOnCombo') : i18n('TryOnSingle')}
    </Button>
  </Space>

  return <div className={css.root}>
    <div className={css.blur} />
    <Vertical className={clsx(css.content, opt.sochi && css.sochi)} round={24}>
      {opt.sochi && button}
      <MainCard />
      {mix && <ItemsPane />}
      {!opt.sochi && button}
      <Space className={css.close}>
        <Button action={onClose}>
          <Icon size={32} name="close" />
        </Button>
      </Space>
    </Vertical>
  </div>
})
